import axios from '@/plugins/axios';

const initialState = () => {
    return {
        vacations: [],
        notConfirmedVacations: []
    };
};

const state = () => initialState();

const getters = {
    getVacations: state => state.vacations,
    getNotConfirmedVacations: state => state.notConfirmedVacations,
    getVacationById: state => vacationId =>
        state.vacations.find(vacation => vacation.id === vacationId)
};

const mutations = {
    setVacations: (state, vacations) => {
        state.vacations = vacations;
    },
    setNotConfirmedVacations: (state, vacations) => {
        state.notConfirmedVacations = vacations;
    },
    addVacation: (state, vacation) => {
        state.vacations.unshift(vacation);
    },
    addNotConfirmedVacation: (state, vacation) => {
        state.notConfirmedVacations.unshift(vacation);
    },
    deleteVacation: (state, vacation) => {
        state.vacations = state.vacations.filter(v => v.id !== vacation.id);
    },
    deleteNotConfirmedVacation: (state, vacation) => {
        state.notConfirmedVacations = state.notConfirmedVacations.filter(
            v => v.id !== vacation.id
        );
    },
    setVacation: (state, vacation) => {
        const vacationIndex = state.vacations.findIndex(
            v => v.id === vacation.id
        );

        if (~vacationIndex) {
            state.vacations.splice(vacationIndex, 1, vacation);
        }
    },
    setNotConfirmedVacation: (state, vacation) => {
        const vacationIndex = state.notConfirmedVacations.findIndex(
            v => v.id === vacation.id
        );

        if (~vacationIndex) {
            state.notConfirmedVacations.splice(vacationIndex, 1, vacation);
        }
    },
    clearState: state => {
        state.vacations = [];
        state.notConfirmedVacations = [];
    }
};

const actions = {
    async fetch({ commit }) {
        const { data } = await axios.get('/vacations');

        commit('setVacations', data);

        return data;
    },

    async fetchNotConfirmed({ commit }) {
        const { data } = await axios.get('/vacations', {
            params: {
                filter: {
                    isConfirmed: false
                }
            }
        });

        commit('setNotConfirmedVacations', data);

        return data;
    },

    async save({ commit, rootGetters, dispatch }, vacation) {
        if (vacation.id) {
            const { data } = await axios.put(
                `/vacations/${vacation.id}`,
                vacation
            );

            commit('setVacation', data);

            if (!data.isConfirmed) {
                commit('setNotConfirmedVacation', data);
            }

            if (rootGetters['auth/isAdmin']) {
                commit('users/setUser', data.user, { root: true });
            }
        } else {
            const { data } = await axios.post('/vacations', vacation);

            commit('addVacation', data);

            if (!data.isConfirmed) {
                commit('addNotConfirmedVacation', data);
            }

            if (rootGetters['auth/isAdmin']) {
                commit('users/setUser', data.user, { root: true });
            }
        }

        if (!rootGetters['auth/isAdmin']) {
            await dispatch('auth/fetchUsersStats', null, { root: true });
        }
    },

    async confirm({ commit }, id) {
        const { data } = await axios.put(`/vacations/${id}/confirm`);

        commit('deleteNotConfirmedVacation', data);
        commit('setVacation', data);
    },

    async delete({ commit, rootGetters, getters, dispatch }, vacationId) {
        await axios.delete(`/vacations/${vacationId}`);

        const vacation = getters.getVacationById(vacationId);

        commit('deleteVacation', vacation);
        commit('deleteNotConfirmedVacation', vacation);

        if (rootGetters['auth/isAdmin']) {
            const { data } = await axios.get(`/users/${vacation.userId}`);

            commit('users/setUser', data, { root: true });
        }

        if (!rootGetters['auth/isAdmin']) {
            await dispatch('auth/fetchUsersStats', null, {
                root: true
            });
        }
    },

    async fetchHistoriesByEntityId(vuexContext, entityId) {
        const { data } = await axios.get(`/history/vacations/${entityId}`);

        return data;
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
